

import { useEffect, useRef, useState } from "react";
import { FaBars } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { useSelector } from "react-redux";
// import { logo, qpShortLogo } from "../../constant/imagePath";
import MenuItem from "../../../components/MenuItem";
import classes from "./LeftAside.module.css";
import { decideMenuIcon } from "../../../helpers/decideIcon";

const predictSvgOrClass = (icon) => {
  return icon?.startsWith("custom") ? decideMenuIcon(icon) : <i
    className={`${icon?.iconCssClass} iconClass`}
    style={{ color: "var(--black-color)" }}
  />

}

const LeftAside = ({ sidebarAside,
  isSidebarClose,
  setIsSidebarClose,
  active,
  setActive,
  menuList,
  styles,
  isClickOnToggle,
  setIsClickOnToggle
}) => {

  const activeHandler = (idx) => {
    if (active === idx) {
      setActive(null);
    } else {
      setActive(idx);
    }
  };

  const handleResize = () => {
    if (window.innerWidth <= 992) {
      setIsSidebarClose(true);
    }
  };
  useEffect(() => {
    if (window.innerWidth < 440) {
      setIsSidebarClose(true);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);
  return (
    <aside
      className={[
        styles["sidebar-side-transition"],
        styles["sidebar__sideContent"],
        isSidebarClose && styles["width-0"],
      ].join(" ")}
      ref={sidebarAside}
    >
      <span
        className={[
          styles["sidebar__openerToggle"],
          isSidebarClose && styles["show__openerToggle"],
        ].join(" ")}
        onClick={() => {
          isSidebarClose
            ? setIsClickOnToggle(true)
            : setIsClickOnToggle(false);
          setIsSidebarClose((prev) => !prev);
        }}
      >
        {isSidebarClose && (
          <FaBars
            color={`#fff`}
            className={classes["toogle"]}
            size={20}
          />
        )}
        {!isSidebarClose && (
          <RxCross1
            color={`#fff`}
            className={classes["toggle"]}
            size={20}
            style={{ strokeWidth: "1" }}
          />
        )}
      </span>
      <div
        className={[
          styles["sidebar__mainMenu"],
          styles["overflow-x-hidden"],
        ].join(" ")}
      >
        <div className={classes["menuHeader"]}>
          <h4>
            Explore
          </h4>
        </div>
        <ul className={styles["sidebarList"]}>
          {menuList?.map((item, index) => (
            <MenuItem
              ref={sidebarAside}
              key={index}
              index={index}
              path={item.router}
              text={item.name}
              isParent={item?.parentApplicationAccessId === null}
              listOfOptions={item.subModules}
              icon={
                predictSvgOrClass(item?.iconCssClass)
                // <i
                //   className={`${item?.iconCssClass} iconClass`}
                //   style={{ color: "var(--black-color)" }}
                // />
              }
              isClickOnToggle={isClickOnToggle}
              isSidebarClose={isSidebarClose}
              setIsSidebarClose={(isShow) => setIsSidebarClose(isShow)}
              activeHandler={activeHandler}
              isActive={active === index}
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default LeftAside;



// import React, { useEffect, useState } from "react";
// import { FaArrowLeft } from "react-icons/fa6";
// import MenuItem from "../../../components/MenuItem";
// import classes from "./LeftAside.module.css";
// import { RxCross1 } from "react-icons/rx";

// const LeftAside = ({
//   sidebarAside,
//   isSidebarClose,
//   setIsSidebarClose,
//   active,
//   menuList,
//   styles,
// }) => {
//   const [markAsActive, setMarkAsActive] = useState(0);
//   const [selectedMenu, setSelectedMenu] = useState(menuList[0]);
//   const [isForward, setIsForward] = useState(true);

//   useEffect(() => {
//     if (selectedMenu?.subModules.length) {
//       setMarkAsActive(null);
//     }
//   }, [selectedMenu]);

//   const handleMenuSelect = (index, item) => {
//     if (item?.subModules?.length) {
//       setIsForward(!selectedMenu);
//       setSelectedMenu(item);
//       setMarkAsActive(index);
//     } else {
//       setMarkAsActive(index);
//     }
//   };

//   return (
//     <aside
//       className={[
//         classes["sidebar-side-transition"],
//         classes["sidebar__sideContent"],
//         isSidebarClose && styles["width-0"],
//       ].join(" ")}
//       ref={sidebarAside}
//     >
//       <div
//         className={[
//           classes["sidebar__mainMenu"],
//           classes["overflow-x-hidden"],
//         ].join(" ")}
//       >
//         <div
//           className={[
//             classes["sidebar__header"],
//             classes["sidebarList"],
//             classes["overflow-x-hidden"],
//           ].join(" ")}
//           style={{
//             marginLeft: "10px",
//             display: "flex",
//             gap: "5px",
//             alignItems: "center",
//           }}
//         >
//           {selectedMenu?.subModules.length ? (
//             <FaArrowLeft
//               color={"var(--black-color)"}
//               size={20}
//               onClick={() => {
//                 setIsForward(true);
//                 setSelectedMenu(menuList[0]);
//               }}
//               style={{ margin: "20px 0px" }}
//               className="c-p"
//             />
//           ) : (
//             ""
//           )}
//           <div className={classes["menuHeader"]}>
//             <h4>
//               {selectedMenu?.subModules.length ? selectedMenu?.name : "Explore"}
//             </h4>
//             <span onClick={setIsSidebarClose}>x</span>
//           </div>
//         </div>

//         {!selectedMenu?.subModules.length ? (
//           <ul
//             className={[
//               classes["sidebarList"],
//               isForward ? classes["slideIn"] : classes["slideOut"],
//             ].join(" ")}
//           >
//             {menuList?.map((item, index) => (
//               <MenuItem
//                 path={!item?.subModules.length && item?.router}
//                 text={item?.name}
//                 icon={<i className={item?.iconCssClass}></i>}
//                 setMarkAsActive={() => {
//                   handleMenuSelect(index, item);
//                 }}
//                 markAsActive={markAsActive === index}
//                 key={index}
//               />
//             ))}
//           </ul>
//         ) : (
//           <ul
//             className={[
//               classes["sidebarList"],
//               !isForward ? classes["slideInLeft"] : classes["slideOutRight"],
//             ].join(" ")}
//           >
//             {selectedMenu?.subModules?.map((item, index) => (
//               <MenuItem
//                 key={index}
//                 path={item?.router}
//                 text={item?.name}
//                 icon={<i className={`${item?.iconCssClass}`} />}
//                 setMarkAsActive={() => {
//                   handleMenuSelect(index, item);
//                 }}
//                 active={markAsActive === index}
//               />
//             ))}
//           </ul>
//         )}
//       </div>
//     </aside>
//   );
// };

// export default LeftAside;

